/* eslint-disable no-underscore-dangle */
class PlanErrorHelper {
  private _shoeUpdatePlanModal;

  bindActions = (showUpdatePlanModal) => {
    this._shoeUpdatePlanModal = showUpdatePlanModal;
  };

  showModal = (
    title: string,
    contents: string[],
    showButtons: boolean,
    redirectTo?: string,
  ) => this._shoeUpdatePlanModal(title, contents, showButtons, redirectTo);
}

export default PlanErrorHelper;
